import {NotificationsResource} from '@//common/api';
import {getCurrentInstance, onBeforeUnmount, ref} from 'vue';
import {defineStore} from 'pinia';
import {notificationsEndpoints} from './notifications.endpoints';

const EVERY_MINUTE = 60000;

export const useNotifications = defineStore('notifications-store', () => {
    const notificationsRecord = ref<NotificationsResource>();

    const fetchInterval = setInterval(fetchNotifications, EVERY_MINUTE);

    async function fetchNotifications() {
        try {
            const notifications = await notificationsEndpoints().notifications();
            notificationsRecord.value = notifications;
        } catch (e) {
            console.error('Failed to fetch notifications with error: ', e);
        }
    }

    if (getCurrentInstance()) {
        onBeforeUnmount(() => {
            clearInterval(fetchInterval);
        });
    }

    return {
        notificationsRecord,
    };
});
